/**
 * Seatics mobile ticket-row CTAs are sometimes <a href="#"> (or javascript:void).
 * On iOS Safari / WKWebView that first dummy-hash navigation adds a history
 * entry and can remount the listing page — drawer flashes open then closes.
 * preventDefault stops the navigation; Seatics still receives the click.
 */

export const SEATICS_HASH_GUARD_ROOT_SELECTOR =
  '#tn-maps, #sea-mp, [data-seatics-chrome="1"]';

export const isSeaticsDummyHashHref = href => {
  const raw = String(href || '').trim();
  if (!raw || raw === '#' || raw === '#!') return true;
  if (/^javascript:/i.test(raw)) return true;
  return false;
};

export const installSeaticsHashNavigationGuard = (cancelled = () => false) => {
  if (typeof document === 'undefined') return () => {};

  const onClick = event => {
    if (cancelled()) return;
    const el = event.target;
    if (!(el instanceof Element)) return;
    const anchor = el.closest('a[href]');
    if (!anchor) return;
    if (!anchor.closest(SEATICS_HASH_GUARD_ROOT_SELECTOR)) return;
    const href = anchor.getAttribute('href');
    if (!isSeaticsDummyHashHref(href)) return;
    event.preventDefault();
  };

  document.addEventListener('click', onClick, true);
  return () => {
    document.removeEventListener('click', onClick, true);
  };
};
